export default [
  {
    path: '/apps/tipo-comunicado/list',
    name: 'apps-tipo-comunicado-list',
    component: () => import('@/views/cadastros/comunicado/tipo-comunicado/list/Index.vue'),
    meta: {
      pageTitle: 'Tipo Comunicado',
    },
  },
];
